// auth.ts — Endpoints d'authentification.
import { req } from './_internals.js';

export const authApi = {
  login: (d: unknown) => req('POST', '/auth/login', d),
  logout: () => req('POST', '/auth/logout'),
  me: () => req('GET', '/auth/me'),
  myQuotas: () => req('GET', '/auth/me/quotas'),
  register: (d: unknown) => req('POST', '/auth/register', d),
  changePassword: (d: unknown) => req('POST', '/auth/change-password', d),
};
